import React from 'react'
import { ContentfulNextJsImage } from '../../../components/common/ContentfulImage'
import { IMarketingCategoryCard } from '@pageFeatures/category/category.types'
import { useDevice } from '@utils/responsiveness/useDevice'
import { Button } from '@noissue-ui-kit/button'
import { mapTextColorToClass } from 'app/_components/ContentfulPage/ConfigurableText/ConfigurableText.utils'
import { titleSizeToClass } from 'app/_components/ContentfulPage/contentfulPage.utils'

export function MarketingTile({
  title,
  titleColor,
  titleSize,
  subtitle,
  subtitleColor,
  backgroundColor,
  desktopImage,
  mobileImage,
  desktopLayout,
  mobileLayout,
  className,
  link,
  ctaLabel,
}: IMarketingCategoryCard & { className?: string }) {
  const { isMobile } = useDevice()
  const isWide = desktopLayout === 'feature'

  const whiteButtonClasses =
    'text-white hover:!bg-white hover:!text-acai !border-white hover:!border-white'

  return (
    <div
      className={`flex flex-col justify-between h-full rounded-[32px] relative overflow-hidden min- ${
        isWide ? 'p-12 sm:p-20' : 'p-12'
      } ${
        desktopImage?.imageUrl || mobileImage?.imageUrl
          ? 'min-h-[430px]'
          : 'h-full sm:min-h-[430px]'
      } ${className}`}
      style={{
        backgroundColor: `${backgroundColor}`,
      }}
    >
      {(desktopImage?.imageUrl || (isMobile && mobileImage?.imageUrl)) && (
        <ContentfulNextJsImage
          src={
            (isMobile && mobileImage?.imageUrl
              ? mobileImage?.imageUrl
              : desktopImage?.imageUrl) || ''
          }
          fill={true}
          backgroundColour={backgroundColor}
          alt={desktopImage?.imageTitle}
          format="jpg"
          className="rounded-2xl lg:rounded-3xl absolute top-0 bottom-0 left-0 right-0"
          key={desktopImage?.imageTitle}
        />
      )}

      <div
        className={`flex relative font-mori ${
          isWide
            ? 'mb-auto sm:mb-0 sm:mt-auto flex-col sm:flex-row sm:items-end justify-between'
            : 'mb-auto flex-col'
        }`}
      >
        <div
          className={`flex flex-col ${
            isWide ? 'w-full sm:max-w-[60%]' : 'w-full'
          }`}
        >
          <h1
            className={`mb-4 text-3xl leading-snug font-bold ${
              !isMobile ? titleSizeToClass[titleSize] : 'text-3xl'
            } ${mapTextColorToClass[titleColor]}`}
          >
            {title}
          </h1>

          <h2
            className={`font-normal max-h-28 text-[18px] sm:text-3xl ${mapTextColorToClass[subtitleColor]}`}
          >
            {subtitle}
          </h2>
        </div>

        {link && (
          <Button
            variant="outline"
            colour="acai"
            size="m"
            corners="rounded"
            Component="a"
            href={link}
            className={`relative w-auto mt-6 bg-transparent ${
              titleColor === 'white' ? whiteButtonClasses : ''
            }`}
          >
            {ctaLabel || 'Shop now'}
          </Button>
        )}
      </div>
    </div>
  )
}
